export default "__VITE_ASSET__da6c7bd1__"